import React from 'react';
import { Button } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';

const DateSelector = ({ dates, currentIndex, onChange, slotCounts = {} }) => {
  if (!dates || dates.length === 0) return null;

  const formatDay = (dateStr) => new Date(dateStr).getDate();
  const formatDow = (dateStr) =>
    new Date(dateStr).toLocaleDateString('fr-FR', { weekday: 'short' }).substring(0, 3).toUpperCase();
  const formatMonth = (dateStr) =>
    new Date(dateStr).toLocaleDateString('fr-FR', { month: 'short' });

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '8px 0' }}>
      <Button
        type="text"
        icon={<LeftOutlined />}
        disabled={currentIndex === 0}
        onClick={() => onChange(currentIndex - 1)}
        size="small"
      />

      <div style={{
        display: 'flex',
        gap: 10,
        flex: 1,
        overflowX: 'auto',
        padding: '14px 4px 4px',
        scrollbarWidth: 'none',
      }}>
        {dates.map((date, index) => {
          const isSelected = index === currentIndex;
          const count = slotCounts[date] || 0;
          return (
            <div
              key={date}
              onClick={() => onChange(index)}
              style={{
                position: 'relative',
                minWidth: 68,
                padding: '10px 8px',
                borderRadius: 12,
                textAlign: 'center',
                cursor: 'pointer',
                transition: 'all 0.2s',
                background: isSelected ? '#059669' : '#f9fafb',
                color: isSelected ? 'white' : '#111827',
                border: isSelected ? '2px solid #059669' : '2px solid #e5e7eb',
                flexShrink: 0,
              }}
            >
              {/* Badge count */}
              {count > 0 && (
                <div style={{
                  position: 'absolute',
                  top: -10,
                  right: -6,
                  minWidth: 20,
                  height: 20,
                  borderRadius: 10,
                  background: isSelected ? '#047857' : '#059669',
                  color: 'white',
                  fontSize: 11,
                  fontWeight: 700,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '0 5px',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
                }}>
                  {count}
                </div>
              )}
              <div style={{
                fontSize: 11,
                fontWeight: 600,
                opacity: isSelected ? 0.9 : 0.5,
                letterSpacing: 0.5,
              }}>
                {formatDow(date)}
              </div>
              <div style={{
                fontSize: 22,
                fontWeight: 700,
                lineHeight: 1.3,
              }}>
                {formatDay(date)}
              </div>
              <div style={{
                fontSize: 11,
                opacity: isSelected ? 0.9 : 0.5,
                textTransform: 'capitalize',
              }}>
                {formatMonth(date)}
              </div>
            </div>
          );
        })}
      </div>

      <Button
        type="text"
        icon={<RightOutlined />}
        disabled={currentIndex === dates.length - 1}
        onClick={() => onChange(currentIndex + 1)}
        size="small"
      />
    </div>
  );
};

export default DateSelector;
